<template>
  <div class="member-box" id="member">
    <div class="">
      <div class="member-top">
        <h1>{{ $t("member.title") }}</h1>
        <p>{{ $t("member.describe") }}</p>
      </div>
      <div class="member-view">
        <div v-for="(item, index) in  memberList " :key="index" class="member-item">
          <img :src="'./static/image/' + item.img" alt="" />
          <div>
            <p>{{ item.name }} | {{ item.position }}</p>
            <p>{{ item.company }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="JoinUs">
      <div>
        <p>
          {{ $t("member.JoinUs") }}
        </p>
        <p>
          <el-button round @click="onClick"> {{ $t("member.button") }}</el-button>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => {
    return {
      memberList: [],
    };
  },
  computed: {
    // list() {
    //   return this.$t("member.list");
    // },
  },
  created() {
    this.intData()
  },
  methods: {
    onClick() {
      window.scrollTo({ top: 50000 });
    },
    intData() {
      //引用axios
      const lang = localStorage.getItem("lang");
      switch (lang) {
        case 'en':
          axios.get("/static/lang/en.json", {})
            .then(({ data }) => {
              console.log('获取到的json数据', data);
              this.memberList = data.MemberList
            })
          break;
        case 'Czh':
          //获取数据（访问路径不用带public ，直接访问public下的文件即可）
          axios.get("/static/lang/Czh.json", {})
            .then(({ data }) => {
              console.log('获取到的json数据', data);
              this.memberList = data.MemberList
            })

          break;

        default:
          //获取数据（访问路径不用带public ，直接访问public下的文件即可）
          axios.get("/static/lang/zh.json", {})
            .then(({ data }) => {
              console.log('获取到的json数据', data);
              this.memberList = data.MemberList
            })

          break;
      }

    },
  },
};
</script>
<style lang="less" scoped>
.member-box {
  width: 100%;
  background-color: #f1f3f8;
  padding-top: 60px;

  >div {
    width: 1280px;
    margin: auto;
  }

  .member-top {
    h1 {
      font-size: 40px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 56px;
      margin-bottom: 10px;
    }

    p {
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 22px;
    }
  }

  .member-view {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 40px;

    .member-item {
      display: flex;
      flex-direction: column;
      width: 290px;
      margin-top: 26px;

      // height: 351px;
      img {
        width: 290px;
        height: 351px;
        background: #b4c1d0;
        border-radius: 8px;
        cursor: pointer;
      }

      >div {
        height: 106px;
        cursor: pointer;
      }

      p:nth-of-type(1) {
        font-size: 24px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 33px;
        margin-top: 24px;
      }

      p:nth-of-type(2) {
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #616364;
        line-height: 22px;
        margin-top: 5px;
      }
    }

    .member-item:not(:nth-of-type(4n + 4)) {
      margin-right: 30px;
    }
  }

  .JoinUs {
    width: 100%;
    height: 240px;
    background-image: url("@/assets/jionUsBg.png");
    background-position: center;
    background-size: cover;
    margin-top: 60px;

    div {
      width: 1280px;
      height: 240px;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      p:nth-child(1) {
        font-size: 32px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }

      p:nth-child(2) {
        .el-button {
          width: 160px;
          height: 54px;
          border-radius: 27px;
          border-color: #f74a00;
          color: #f74a00;
        }
      }
    }
  }
}

@media screen and (max-width: 1080px) {
  .member-box {
    width: 100%;
    background-color: #f1f3f8;
    padding-top: 8rem;

    >div {
      width: 108rem;
      margin: auto;
      padding: 5rem;
      box-sizing: border-box;
    }

    .member-top {
      h1 {
        font-size: 5.3rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 7.3rem;
        margin-bottom: 2rem;
      }

      p {
        font-size: 3rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 4.3rem;
      }
    }

    .member-view {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 4rem;

      .member-item {
        display: flex;
        flex-direction: column;
        width: 46rem;
        margin-top: 5rem;

        // height: 351px;
        img {
          width: 46rem;
          height: 55.3rem;
          background: #b4c1d0;
          border-radius: 1.2rem;
        }

        >div {
          min-height: 20rem;
        }

        p:nth-of-type(1) {
          font-size: 4.5rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 6.3rem;
          margin-top: 5rem;
        }

        p:nth-of-type(2) {
          font-size: 3.3rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #616364;
          line-height: 4.5rem;
          margin-top: 1rem;
        }
      }

      .member-item:not(:nth-of-type(4n + 4)) {
        margin-right: 0;
      }
    }

    .JoinUs {
      width: 108rem;
      height: 37rem;
      background-image: url("@/assets/jionUsBg.png");
      background-position: center;
      background-size: cover;
      margin-top: 6rem;
      padding: 0;

      div {
        width: 108rem;
        height: 37rem;
        margin: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        p:nth-child(1) {
          width: 54rem;
          text-align: center;
          font-size: 5.3rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          margin-bottom: 4rem;
        }

        p:nth-child(2) {
          .el-button {
            width: 26.2rem;
            height: 11.1rem;
            border-radius: 5.6rem;
            border-color: #f74a00;
            color: #f74a00;
          }
        }
      }
    }
  }
}
</style>